import { CardDetailsData } from "@/features/cards/types/CardDetails.type";
import { ConsumptionValidationSchema } from "../schemas/create.schema";
import { UseFormSetValue } from "react-hook-form";
import React, { useEffect } from "react";
import { cardDetailsComponents } from "../constants/cardDetails.constant";
import type { CompanyData } from "@/features/companies/types/companies.type";
import { cardStatusTranslation } from "@/features/cards/constants/cardStatusTranslation.constant";
import { CircleXIcon } from "lucide-react";
import { cardStatusAvailableToConsumption } from "@/features/cards/constants/cardStatusAvailableToConsumption.constant";
import Alert from "@/common/components/Alert";

interface EquipmentInfoProps {
  cardDetails?: CardDetailsData;
  setValue: UseFormSetValue<ConsumptionValidationSchema>;
  companyData: CompanyData;
}

const EquipmentInfo = ({ cardDetails, setValue, companyData }: EquipmentInfoProps) => {
  useEffect(() => {
    if (cardDetails && cardDetails?.id) {
      setValue("card_id", cardDetails?.id);
      setValue("card_type", cardDetails?.type);
    }
  }, [cardDetails?.id]);

  if (!cardDetails?.id) {
    return (
      <Alert Icon={CircleXIcon} variant="error">
        <p className="text-danger-soft text-sm" data-testid="alert_card_not_found">
          Cartão não encontrado
        </p>
      </Alert>
    )
  }

  return (
    <>
      {React.createElement(
        cardDetailsComponents[cardDetails?.type as keyof typeof cardDetailsComponents], { cardDetails, companyData }
      )}

      {!(cardStatusAvailableToConsumption).includes(cardDetails.status) && (
        <div className="flex items-center gap-3 bg-danger-soft/15 p-4 rounded-lg" data-testid="alert_card_status_not_available">
          <CircleXIcon strokeWidth={1.5} className="text-danger-soft size-5" />

          <div className="flex flex-col gap-y-px">
            <p className="text-danger-soft text-sm">
              Cartão com status indisponível para uso
            </p>

            <p className="text-danger-soft text-xs">
              Status: {cardStatusTranslation[cardDetails.status]}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default EquipmentInfo;
